import { css } from "@emotion/core";

export const override = css`
  display: inlink-block;
`;
